// extracted by mini-css-extract-plugin
module.exports = {"wContainer":"priceFAQ-module--wContainer--1xjAv","textGroupContainer":"priceFAQ-module--textGroupContainer--2Amr5","orangeLine":"priceFAQ-module--orangeLine--20uIJ"};